import axios from "axios";

export function getProducts(page=1) {
    return axios.get('products?page=' + page);
}

export function getProduct(id) {
    return axios.get('product/' + id);
}